import {
  NgModule,
} from '@angular/core';
import {
  JourneysBaseModule,
} from '@des/services/journeys';
import {
  JourneyAlternativeOffersStoreModule,
} from '@des/store/journey-alternative-offers';
import {
  JourneysStoreModule,
} from '@des/store/journeys';
import {
  RegulatoryDetailsStoreModule,
} from '@des/store/regulatory-details';
import {
  StoresPendingGuard,
} from './stores-pending.guard';

@NgModule({
  imports: [
    JourneysBaseModule,
    JourneysStoreModule,
    RegulatoryDetailsStoreModule,
    JourneyAlternativeOffersStoreModule
  ],
  providers: [StoresPendingGuard]
})
export class StoresPendingGuardModule {}
